import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage, setTitle, pageLoaded, reportAnalytics } from '../fundialSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import DownloadedSongSuccess from '../Shared/DownloadedSongSuccess/DownloadedSongSuccess'
import SongSetap from '../Shared/SongSetup/SongSetup'
import SurpriseContactsWithSongs from '../Shared/SurpriseContactsWithSongs/SurpriseContactsWithSongs';
import { Container, Col, Row } from 'reactstrap';


const DownloadedSetupPage = (props) => {
  const [successText, setSuccessText] = useState("השיר נשמר ברשימת השירים שלכם");


    useExtendedEffect((runSideEffects) => { 
      window.scrollTo(0, 0);
      if(props.aocDetails.isFirstSong){
        setSuccessText("השיר יוגדר מיד כצליל המתנה בנייד שלכם");
      } 

      if (runSideEffects()) {
        props.setTitle({ titleBold: "בחירת המתנה נעימה", titleRegular: "" })
        props.pageLoaded();
        props.reportAnalytics({
          eventCategory: 'fundial',
          eventAction: "HN_DownloadSuccess_Reveald",
          eventLabel: "",
        });
        if(props.aocDetails.isFirstSong){
          props.reportAnalytics({
            eventCategory: 'fundial',
            eventAction: "HN_DownloadSuccess_FirstDownload_Rev",
            eventLabel: "",
          });
        } 
      }
    }, []);

    function selectAnotherSong() {
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: "HN_DownloadSuccess_ClickCatButton",
        eventLabel: "",
      });
      props.goToPage({page: 'catalogPage'});
      return false;
    }

    function view() {
        return (
          <div className='downloaded-setup-page'>
            <Container>
              <Row className='justify-content-md-center'>
                <Col xs='12' sm='12' md='12' lg='8'>
                  <DownloadedSongSuccess audio={props.selectedSong} successText={successText} />
                  {props.aocDetails.isFirstSong &&
                  <SurpriseContactsWithSongs selectAnotherSong={selectAnotherSong}/>
                  }
                  {!props.aocDetails.isFirstSong &&
                  <SongSetap />
                  }
                </Col>
              </Row>
            </Container>
          </div>
        );
    }


    return (
        <div className='downloaded-setup-page'>
            {view()}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        selectedSong: state.fundialPage.selectedSong,
        aocDetails: state.fundialPage.aocDetails,

    };
};

const mapDispatchToProps = {
    goToPage,
    setTitle,
    showAppLoader,
    hideAppLoader,
    pageLoaded,
    reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadedSetupPage);
